export enum CustomFormQuestionType {
    SINGLE_LINE_TEXT = 1,
    CONTEXTUAL_INFORMATION = 2,
    MULTI_LINE_TEXT = 3,
    MULTIPLE_CHOICE = 4,
    DATE = 5,
    LABEL = 6,
    CHECKBOX = 7,
    DROPDOWN = 8,
    RUBRIC = 9,
    SIGNATURE = 10,
    TIME = 11,
    CALCULATOR = 12
}